@use '~/theme/theme' as *;
@use '~/theme/typography';

.outerContainer {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.checkboxContainer {
  display: flex;
  align-items: center;
  border-radius: 6px;
  margin-top: 1px;
  transition:
    background-color 300ms,
    color 300ms,
    border-color 300ms,
    outline-offset 300ms,
    outline-width 300ms;
}

.checkbox {
  border: 2px var(--checkbox-color) solid;
  border-radius: 4px;
  color: white;
  background: var(--checkbox-background);
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  z-index: 1;
  transition:
    background-color 300ms,
    color 300ms,
    border-color 300ms,
    outline-color 300ms;
}

.icon {
  display: none;
  width: 20px;
  height: 20px;
}

.control {
  --checkbox-color: #{color(grey-800)};
  --checkbox-background: white;
  --hover-color: #{color(violet-200)};
  --label-color: #{color(grey-800)};

  /* Workaround for React Aria VisuallyHidden bug in react-aria-components@1.14.0:
     The absolutely positioned VisuallyHidden input causes a layout shift when
     an offscreen checkbox receives focus inside a scroll container.
     Official fix: https://github.com/adobe/react-spectrum/pull/8091
     Fixed in react-aria-components@1.15.0 — remove this when upgrading. */
  position: relative;

  @include typography.body2;
  @include typography.regular;

  display: flex;
  align-items: flex-start;
  align-self: flex-start;
  gap: spacing(1);
  cursor: pointer;
  color: var(--label-color);

  &[data-focus-visible] .checkbox {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
  }

  &[data-hovered] .checkboxContainer {
    background: var(--hover-color);
    outline: 4px solid var(--hover-color);
  }

  &[data-selected],
  &[data-indeterminate] {
    .checkbox {
      border: none;
      background: var(--checkbox-color);
    }

    .icon {
      display: block;
    }
  }

  &[data-invalid] {
    --checkbox-color: #{color(lobster-800)};
    --hover-color: #{color(lobster-200)};
  }

  &[data-disabled] {
    --checkbox-color: #{color(grey-500)};
    --label-color: #{color(grey-500)};
    --checkbox-background: #{color(grey-200)};

    cursor: unset;

    &[data-invalid] {
      --checkbox-background: #{color(lobster-200)};
    }
  }

  & + div.extraLabel {
    color: var(--label-color);
  }
}

.extraLabel {
  margin-left: 29px;
  margin-top: -6px;
}

.strong {
  @include typography.semibold;
}

.errorMessage {
  color: color(lobster-900);
}
